import React from 'react'

import NavigationMenuSection from "../../../menu-items/section/section"
import NavigationMenuItemTag from "../../../menu-items/tag/menu-item-tag"
import {QuickAddItemType} from "../../../../../app/quick-add/@types"
import {TagType} from "../../../../../app/quick-add/sections/tag/const"
import {SortDirection} from "../../../../../core/data-structures/sort"
import MainMenu_SectionReorderableWithMore from "../../../components/menu-controller/menu-section-reordable-with-more";
import ProjectSession from "../../../../../core/model2/project/project-session";

type Props = {
    tags                : ProjectSession[]
    parentProjectId?    : ID
    showAdd             : boolean
}

const SHOW_MORE_THRESHOLD: number   = 5

// const debug = "NavigationMenuProjectsTags"
const debug = false

export default class NavigationMenu_ProjectsTags extends React.Component<Props> {

    onReorderEnd = (items:any) => {
        const sortPositions = _.map(items, (item:any)=>item.id)

        // collect all tag ids that are not among items (for show less state only visible items are reordered)
        const otherTagsIds = _(this._getOrderedTags())
            .filter((item:any)=>!sortPositions.includes(item.id))
            .map((item:any)=>item.id)
            .value()

        debug && console.log(debug, 'render', [...sortPositions, ...otherTagsIds], sortPositions, otherTagsIds, items)

        gd.user.settings.menu.projectsTags.sortPositions = [...sortPositions, ...otherTagsIds]
        gd.user.settings.menu.save()
    }

    onNewTagClick = ()=>{
        debug && console.log(debug, 'onNewTagClick', this.props.parentProjectId)

        if (this.props.parentProjectId) {
            gd.openNew(
                QuickAddItemType.TAG,
                {
                    company     : gd.companyId,
                    projectId   : this.props.parentProjectId,
                    type        : TagType.PROJECT
                })
        } else {
            gd.openNew(
                QuickAddItemType.TAG,
                {
                    type: TagType.GENERIC
                }
            )
        }
    }

    _getOrderedTags = () => {
        const sortPositions = gd.user.settings.menu.projectsTags.sortPositions
        return _.orderBy(this.props.tags, [
                (item)=>sortPositions.includes(item.id) ? 0 : 1,
                (item)=>_.indexOf(sortPositions, item.id)
            ], [
                SortDirection.ASC,
                SortDirection.ASC
            ])
    }

    render() {

        let components: any[] = _.map(this._getOrderedTags(), (item, key)=>({
            item        : item,
            component   : <NavigationMenuItemTag key       = {key}
                                                 project   = {item}
                                                 colorized = {true}/>
        }))

        return (
            <NavigationMenuSection name         = "Tags"
                                   systemName   = "projectsTags"
                                   collapsible  = {true}
                                   counter      = {this.props.tags.length}>

                <MainMenu_SectionReorderableWithMore countVisibleItems  = {5}
                                                     moreTitle          = "All Tags"
                                                     newItemTitle       = "New tag"
                                                     components         = {components}
                                                     settingsKey        = "project-tags"
                                                     showAdd            = {this.props.showAdd}
                                                     onReorderEnd       = {this.onReorderEnd}
                                                     onClickNew         = {this.onNewTagClick}/>

            </NavigationMenuSection>
        )
    }
}
